import { Progress } from "@chakra-ui/react";
import { useIsFetching } from "@tanstack/react-query";

export const FetchingIndicator = () => {
  const fetchingCount = useIsFetching();
  const isFetching = fetchingCount > 0;

  return (
    <Progress.Root h={2} w="full" striped value={null} pos="absolute">
      <Progress.Track h={2} opacity={isFetching ? 1 : 0}>
        <Progress.Range h={2} />
      </Progress.Track>
    </Progress.Root>
  );
};
